import { useEffect, useState } from 'react';

import { checkTrialPeriod } from 'common/requestHandler';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setTrialModalShown, setTrialPeriod } from '../redux/slices/authSlice';

export const useTrialPeriod = () => {
  const dispatch = useDispatch();
  const { isTrialPeriod, trialPeriodMessage, trialModalShown } = useSelector(
    (state: RootState) => state.auth
  );
  const [showTrialModal, setShowTrialModal] = useState(false);
  const [apiCallMade, setApiCallMade] = useState(false);

  const checkTrialPeriodStatus = async () => {
    // Only make API call once per session
    if (apiCallMade) return;

    try {
      setApiCallMade(true);
      const response = await checkTrialPeriod();
      if ('error' in response) {
        console.error('Trial period check failed:', response.error);
        return;
      }

      const trialMessage = response.data;
      const hasTrialMessage = Boolean(trialMessage && trialMessage.length > 0);

      dispatch(
        setTrialPeriod({
          isTrialPeriod: hasTrialMessage,
          trialPeriodMessage: hasTrialMessage ? trialMessage : null,
        })
      );

      // Only show modal if there's a message and it hasn't been shown before
      if (hasTrialMessage && !trialModalShown) {
        setShowTrialModal(true);
      }
    } catch (error) {
      console.error('Error checking trial period:', error);
    }
  };

  const closeTrialModal = () => {
    setShowTrialModal(false);
    dispatch(setTrialModalShown(true));
  };

  useEffect(() => {
    // Only check trial period if we haven't made the API call yet
    if (!apiCallMade) {
      checkTrialPeriodStatus();
    }
  }, [apiCallMade]);

  return {
    isTrialPeriod,
    trialPeriodMessage,
    showTrialModal,
    closeTrialModal,
    checkTrialPeriodStatus,
  };
};
